import { ButtonSlideCustom, CustomText, ImageAtoms } from '@vfit/shared/atoms';
import {
  ButtonWrapper,
  EsimInstructionContainer,
  EsimInstructionContent,
  ImageWrapper,
  List,
  ListItem,
  Section,
} from './esInstruction.style';
import { IDevice } from './esInstruction.model';
import { fonts } from '@vfit/shared/themes';

const EsInstruction = ({ device }: { device: IDevice }) => {
  const { icon,title, description, instructions, action } = device;
  return (
    <EsimInstructionContainer>
      <EsimInstructionContent>
        <ImageWrapper>
          <ImageAtoms width="75" nameCard="download" image={icon} />
        </ImageWrapper>
        <CustomText
          text={title}
          textAlign="center"
          size={40}
          lineHeight={48}
          margin={[24, 0, 32, 0]}
          fontFamily={fonts.vodafone}
        />
        <CustomText text={description} textAlign="left" size={18} lineHeight={26} margin={[0]} />

        {instructions.map((instruction) => (
          <Section>
            <CustomText
              text={instruction?.title}
              textAlign="left"
              size={18}
              lineHeight={26}
              margin={[20, 0, 0, 0]}
            />
            <List>
              {instruction.steps.map((step) => (
                <ListItem
                  dangerouslySetInnerHTML={{
                    __html: step.name,
                  }}
                />
              ))}
            </List>
          </Section>
        ))}

        <ButtonWrapper>
          <ButtonSlideCustom
            onClick={()=>window.open(action?.link,action?.isBlank === 'true' ? '_blank' : '_self')}
            label={action?.title}
            style={action.style}
          />
        </ButtonWrapper>
      </EsimInstructionContent>
    </EsimInstructionContainer>
  );
};

export default EsInstruction;

